// Live pixel test: open each page (and its thank-you page) in a hidden frame with ?pixel_check=<nonce>.
// The page loads each pixel script without sending any event and posts back what it found.
const WAIT_MS = 20000;
const LABEL = { meta: "Meta", google_ads: "Google Ads", ga4: "Google Analytics", tiktok: "TikTok" };

function frameCheck(origin, path) {
  return new Promise((resolve) => {
    const nonce = Math.random().toString(36).slice(2);
    const frame = document.createElement("iframe");
    frame.src = `${origin}${path}${path.includes("?") ? "&" : "?"}pixel_check=${nonce}`;
    frame.setAttribute("aria-hidden", "true");
    frame.tabIndex = -1;
    Object.assign(frame.style, { position: "fixed", left: "-10000px", top: "0", width: "390px", height: "700px", border: "0" });
    let timer;
    const onMsg = (e) => {
      if (e.origin === origin && e.data?.type === "lf-pixel-check" && e.data.nonce === nonce) done(e.data);
    };
    function done(data) {
      clearTimeout(timer);
      window.removeEventListener("message", onMsg);
      frame.remove();
      resolve(data);
    }
    timer = setTimeout(() => done(null), WAIT_MS);
    window.addEventListener("message", onMsg);
    document.body.appendChild(frame);
  });
}

function judge(expected, data) {
  if (!data) return { ok: false, problem: "Page didn't load or didn't answer within 20 seconds" };
  const got = data.results || [];
  const want = expected.filter((p) => p.loads && LABEL[p.kind]);
  for (const p of want) {
    const r = got.find((g) => g.kind === p.kind && g.id === p.id);
    if (!r) return { ok: false, problem: `${LABEL[p.kind]} ${p.id} isn't on the live page` };
    if (r.loaded === false) return { ok: false, problem: `${LABEL[p.kind]} ${p.id} script was blocked or couldn't load` };
  }
  return { ok: true, problem: null };
}

export async function runLiveTest(rows, origin, onResult) {
  const jobs = rows.flatMap((r) => [
    { key: r.key, surface: "landing", path: r.url, expected: r.landing },
    { key: r.key, surface: "thank_you", path: r.thank_you_url, expected: r.thank_you },
  ]);
  const out = [];
  let next = 0;
  const worker = async () => {
    while (next < jobs.length) {
      const j = jobs[next++];
      const res = { key: j.key, surface: j.surface, ...judge(j.expected, await frameCheck(origin, j.path)) };
      out.push(res);
      onResult(res);
    }
  };
  await Promise.all([worker(), worker(), worker()]);
  return out;
}
